import { render, staticRenderFns } from "./signs.vue?vue&type=template&id=b6aa4c96&"
import script from "./signs.vue?vue&type=script&lang=js&"
export * from "./signs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports